export function cleanFormattingValue(value) {
  // Remove o símbolo de moeda 'R$' e espaços em branco
if (value.toString().includes("R$")) {
    value = value.toString().replace("R$", "").trim();
}
  // Remove pontos de milhar
  value = value.replace(/\./g, "");

  // Substitui vírgulas por pontos para permitir conversão para número
  value = value.replace(",", ".");

  return parseFloat(value);
}
